module.exports = __webpack_public_path__ + "img/Illustration-10.4ba976bf.png";